import Button from "../ui/Button";

const Booking = () => {
  return (
    <div className="bg-secondary p-4 md:p-8 rounded-lg drop-shadow mt-6 md:mt-10 mx-4 md:mx-0">
      <h2 className="text-md md:text-2xl font-semibold text-center text-dim-light mb-3 md:mb-4">
        YOU DESERVE SELF-CARE
      </h2>
      <h3 className="text-xl md:text-3xl font-bold text-center text-gray-900 mb-4 md:mb-6">
        Book An Appointment Today
      </h3>
      <p className="text-center font-body text-gray-700 text-sm md:text-base mb-6 md:mb-8">
        You can call us to book your appointment or you can use our booking form and we'll make a reservation for you.
      </p>
      <div className="flex justify-center gap-4">
        <Button to="../book-massage" size="large" variant='accent' className="w-full md:w-auto">
          BOOK NOW
        </Button>
      </div>
    </div>
  );
};

export default Booking;